import React, {Fragment} from 'react';
import {forgot, handleCloseModal, requestForgot} from '#app/redux/actions/auth'
import Form from "./Form";
import {connect} from "react-redux";
import {Container, GreyText, Text, Wrapper} from "./styles";
import {Button, Input, InputContainer} from "finform";
import {Modal} from "src/interface/modal/Modal";
import {Row} from "../styles";

class Forgot extends Form
{
  constructor(props)
  {
    super(props);

    this.state = {
      ...this.state,
      form: {
        email: '',
        password: '',
        password_confirmation: '',
        code: '',
        captchaValue: '',
        form: 'manager'
      },
      formErrors: {},
      code: false,
      submitted: false,
      checked: false
    };

  }

  submitRequestForgotForm()
  {
    this.setState({
      submitted: true
    }, () =>
    {
      this.props.requestForgot({
        form: this.state.form,
        success: (response, status, xhr) =>
        {
          this.setState({
            code: true,
            submitted: false
          });
        },
        error: (errors) =>
        {
          this.setState({
            submitted: false,
          });
        },
        obj: this
      });
    });
  }

  submitForgotForm()
  {
    this.setState({
      submitted: true
    }, () =>
    {
      this.props.forgot({
        form: this.state.form,
        success: (response, status, xhr) =>
        {
          Modal.handleClose();
          this.props.handleCloseModal();

          this.setState({
            form: {
              email: '',
              password: '',
              password_confirmation: '',
              captchaValue: '',
              code: '',
            },
            submitted: false
          }, () =>
          {
            if (typeof this.props.callback === 'function')
            {
              this.props.callback();
            }
          });
        },
        error: (errors) =>
        {
          this.setState({
            submitted: false,
          });
        },
        obj: this,
        callback: () => {

        }
      });
    });
  }

  submitForm()
  {
    if (this.state.code)
    {
      this.submitForgotForm();
    } else
    {
      this.submitRequestForgotForm()
    }
  }

  renderForm()
  {
    if (this.state.code) {
      return this.renderCodeForm();
    } else {
      return this.renderForgotForm()
    }
  }


  renderCodeForm() {
    return <Wrapper>
      <Container>
        <Fragment>
          <Text white>Введите код отправленный на email </Text>
          <Row>
            <InputContainer error={this.getError('code')}>
              <Input
                  id='forgot-code'
                  type="text"
                  name="code"
                  value={this.state.form.code}
                  onChange={(value) =>
                  {
                    this.setState((prv) =>
                    {
                      prv.form.code = value;
                      if(prv.formErrors)
                      {
                        prv.formErrors.code = {};
                      }

                      return prv;
                    });
                  }}
                  placeholder={'Код'}
              />
            </InputContainer>
          </Row>
          <h3>Придумайте новый пароль</h3>
          <Row>
            <InputContainer error={this.getError('password')}>
              <Input
                id='forgot-password'
                type="password"
                name="password"
                value={this.state.form.password}
                onChange={(value) =>
                {
                  this.setState((prv) =>
                  {
                    prv.form.password = value;
                    if(prv.formErrors)
                    {
                      prv.formErrors.password = {};
                    }
  
                    return prv;
                  });
                }}
                placeholder={'Новый пароль'}
              />
            </InputContainer>
          </Row>
          <Row>
            <InputContainer error={this.getError('password_confirmation')}>
              <Input
                id='forgot-password_confirmation'
                type="password"
                name="password_confirmation"
                value={this.state.form.password_confirmation}
                onChange={(value) =>
                {
                  this.setState((prv) =>
                  {
                    prv.form.password_confirmation = value;
                    if(prv.formErrors)
                    {
                      prv.formErrors.password_confirmation = {};
                    }

                    return prv;
                  });
                }}
                placeholder={'Повтор нового пароля'}
              />
            </InputContainer>
          </Row>
        </Fragment>
        <GreyText>(напишите на info@blackswan.finance если код не приходит)</GreyText>
        <Row>
          <Button wide id='forgot-submit' onClick={() => {
            this.submitForm();
          }}>Сохранить</Button>
        </Row>
      </Container>
    </Wrapper>
  }

  renderForgotForm() {
    return <Wrapper>
      <Container>
        <Row>
          <InputContainer error={this.getError('email')}>
            <Input
              id='forgot-email'
              type="text"
              name="email"
              value={this.state.form.email}
              onChange={(value) =>
              {
                this.setState((prv) =>
                {
                  prv.form.email = value;
                  if(prv.formErrors)
                  {
                    prv.formErrors.email = {};
                  }

                  return prv;
                });
              }}
              placeholder={'Email'}
            />
          </InputContainer>
        </Row>
        <Row>
          <Button wide className='style2' id='forgot-submit' onClick={() => {
            this.submitForm();
          }}>Восстановить</Button>
        </Row>
      </Container>
    </Wrapper>
  }

  render()
  {
    return this.renderForm();
  }
}

const enhance = connect(
  state => ({}),
  { forgot, requestForgot, handleCloseModal}
)

export default enhance(Forgot)
